import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { AutomationRuleEnums } from "models/enums";
import { AutomationRuleFormTypes } from "models/formTypes";
import { AutomationRuleCreationFormViewProps } from "models/propTypes/automationRulePropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { ChoiceProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region  components
import { Choice, useWintForm, VerticalFormField, WintForm } from "components/common/wintForms";
import { ReceiptDraftCreateSection } from "components/automationRule/forms/receiptDraft";
//#endregion
import { TranslationKeys } from "translations";

const RuleCreationForm: ForwardRefRenderFunction<FormHandles, AutomationRuleCreationFormViewProps> = (props, ref) => {
  const { availableRuleTypes, defaultValues, validationSchema, handleSubmit, isEditView } = props;
  const { wintFormProps, connect, values } = useWintForm<AutomationRuleFormTypes.AutomationRuleCreate>({
    formRef: ref,
    defaultValues: defaultValues,
    validationSchema: validationSchema,
    handleSubmit: handleSubmit,
    enableReinitialize: true,
    validateOnBlur: true,
  });

  const receiptDraft = values.type === AutomationRuleEnums.AutomationRuleType.ReceiptDraft;

  return (
    <WintForm {...wintFormProps}>
      <VerticalFormField<ChoiceProps>
        Component={Choice}
        {...connect("type")}
        label={TranslationKeys.AutomationRule.TypeTitle}
        showMainLabel
        items={availableRuleTypes}
        disabled={isEditView}
      />
      {receiptDraft ? <ReceiptDraftCreateSection connect={connect} isEditView={isEditView} /> : <></>}
    </WintForm>
  );
};

export default forwardRef(RuleCreationForm);
